(function () {
  function setupHeading() {
    var heading = document.querySelector('.blog-notes__heading');
    if (!heading || heading.dataset.ready === 'true') return;

    var text = heading.getAttribute('data-type-text') || heading.textContent;
    heading.textContent = '';
    heading.dataset.ready = 'true';

    text.split('').forEach(function (ch, i) {
      var span = document.createElement('span');
      span.textContent = ch === ' ' ? '\u00A0' : ch;
      span.style.animationDelay = (i * 0.07) + 's';
      heading.appendChild(span);
    });

    return heading;
  }

  function init() {
    var heading = setupHeading();
    if (!heading) heading = document.querySelector('.blog-notes__heading');
    if (!heading) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('blog-notes__heading')) {
            entry.target.querySelectorAll('span').forEach(function (s) {
              s.classList.add('on');
            });
          } else {
            entry.target.classList.add('animate');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });

    observer.observe(heading);

    document.querySelectorAll('.blog-notes__card').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();